<template>
  <widget collapsable collapse  icon="fas fa-info-circle" class="bg-gray text-primary border-seconda" name="about" 
  title="About">
  <p class="lead">
    Simple, clean and modern mobile app for Muslims <em>For the better of Muslim Being.</em>
    Additional tools/widgets - Islamic Calendar, Qur'an Radio and more - coming soon إنشاء الله. 
    </p>

    <footer slot="footer" class="p-2 bg-light text-center">
      <p class="m-0 text-gray"><small><i>IslamIslamic.com | Islami.app</i> | created by Alamin Ahmed</small></p>
      <cite class="text-gray" title="Source Title">Icons made by <a href="http://www.freepik.com" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed by <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">CC 3.0</a></cite>
    </footer>
  </widget>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/widgets/About.vue